function init() {
    $("[data-specialist]").on("click", function() {
        $(".specialist").hide();
        $("." + $(this).data("specialist")).show();
    });
}

export default { init };
